var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"envset"}},[(_vm.envList.length > 1)?_c('div',[_c('v-select',{attrs:{"dense":"","hide-details":"","item-text":"label","item-value":"value","items":_vm.envList,"value":_vm.environment,"return-object":""},on:{"input":(v) => _vm.updateEnvironment(v)}})],1):_c('div',{staticClass:"subtitle-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }